import axios from 'axios'
import Utils from '../utils/utils'
import CONST from '../utils/const'

export async function getNorthVDData(condition = {}) {
    let response = {}
    try {
        response = await axios.get('https://traffic.transportdata.tw/MOTC/v2/Road/Traffic/Live/VD/Highway/VD-43-0110-006-01?%format=JSON')

    } catch (err) {
        console.error('iisi getMiddleVDData: ', err)
        return null
    }

    //LinkID:"3001100000534U" 進  LinkID:"3001100100534U" 出 
    return handleVehicles(response, '3001100000534U', '3001100100534U')
}

export async function getMiddleVDData(condition = {}) {
    let response = {}
    try {
        response = await axios.get('https://traffic.transportdata.tw/MOTC/v2/Road/Traffic/Live/VD/Highway/VD-46-0300-025-01?%24top=30&%24format=JSON')

        // VD-46-0300-025-01  另一隻api    3003000002514U進   3003000102514U出     

    } catch (err) {
        console.error('iisi getMiddleVDData: ', err)
        return null
    }

    // VD-46-0300-028-01  LinkID:"3003000002876V" 進, LinkID:"3003000102876V" 出
    return handleVehicles(response, '3003000002514U', '3003000102514U')
}

export async function getSouthVDData(condition = {}) {
    let response = {}
    try {
        response = await axios.get('https://traffic.transportdata.tw/MOTC/v2/Road/Traffic/Live/VD/Highway/VD-33-0110-161-01?%format=JSON')


    } catch (err) {
        console.error('iisi getMiddleVDData: ', err)
        return null
    }

    //LinkID:"3001100116009V" 進, LinkID:"3001100016013V" 出
    return handleVehicles(response, '3001100116009V', '3001100016013V')
}

function handleVehicles(response, inId, outId) {

    if (Utils.isEmptyObject(response.data) || Utils.isEmptyObject(response.data.VDLives[0]) || Utils.isEmptyObject(response.data.VDLives[0].LinkFlows)) {
        return null
    }

    const linkFlows = response.data.VDLives[0].LinkFlows
    let inData = null
    let outData = null
    for (let i = 0; i < linkFlows.length; i++) {
        const id = linkFlows[i].LinkID
        const lanes = linkFlows[i].Lanes
        let amount = Object.assign({}, CONST.VD_INIT_DATA); // avoid call by reference issue (if amount = CONST.VD_INIT_DATA directly)

        for (let j = 0; j < lanes.length; j++) {
            const vehicles = lanes[j].Vehicles

            for (let k = 0; k < vehicles.length; k++) {
                //Volume -99表示   表示設備異常
                amount[vehicles[k].VehicleType] = vehicles[k].Volume < 0 ? '-' : amount[vehicles[k].VehicleType] + vehicles[k].Volume
            }
        }

        if (id === inId ) {
            inData = amount
        }

        if (id === outId) {
            outData = amount
        }

    }

    return {
        inData,
        outData
    }
}